(() => {
  const init=()=>{
    const root=document.querySelector('[data-pc-detail]');
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    root.querySelectorAll('video').forEach(v=>{v.muted=true;v.play().catch(()=>{});});
    const links=[...root.querySelectorAll('.pc-nav-links a')];
    const nav=root.querySelector('.pc-nav');
    const spacer=document.createElement('div');
    spacer.setAttribute('aria-hidden','true');
    nav.before(spacer);
    const hostIds={reviews:'pc-reviews-title',recommended:'pc-recommended-title'};
    const revealHosts=()=>links.filter(a=>a.dataset.hostNav).forEach(a=>{a.hidden=!document.getElementById(hostIds[a.dataset.hostNav]);});
    revealHosts();
    const header=document.querySelector('#shopify-section-header-inline');
    const updateTop=()=>{
      let top=0;
      if(header){const style=getComputedStyle(header);const rect=header.getBoundingClientRect();if(['fixed','sticky'].includes(style.position)&&rect.bottom>0)top=Math.min(rect.height,rect.bottom);}
      document.querySelectorAll('.pc').forEach(e=>e.style.setProperty('--pc-nav-top',`${top}px`));
      const fixed=spacer.getBoundingClientRect().top<=top;
      spacer.style.height=fixed?`${nav.offsetHeight}px`:'0px';
      nav.classList.toggle('is-fixed',fixed);
    };
    updateTop();
    let frame=0;
    const update=()=>{
      frame=0;updateTop();revealHosts();
      const navBottom=root.querySelector('.pc-nav').getBoundingClientRect().bottom;
      let active=links[0];
      for(const link of links){const target=document.getElementById(link.hash.slice(1));if(target&&target.getBoundingClientRect().top<=navBottom+100)active=link;}
      links.forEach(a=>a===active?a.setAttribute('aria-current','location'):a.removeAttribute('aria-current'));
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    addEventListener('scroll',schedule,{passive:true});
    addEventListener('resize',schedule,{passive:true});
    if(header&&'ResizeObserver'in window)new ResizeObserver(schedule).observe(header);
    links.forEach(link=>link.addEventListener('click',event=>{
      const target=document.getElementById(link.hash.slice(1));if(!target)return;
      event.preventDefault();
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
      history.replaceState(null,'',link.hash);
    }));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
